import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { share } from '../../../appRedux/actions/Share'

import { Card, Button, Checkbox, Form, Icon, Input, InputNumber, Select, Spin, message, Popconfirm } from "antd";
import { CheckCircleTwoTone } from '@ant-design/icons';

const ShareSection = ({ form, editFormContents }) => {
    const { shareData } = useSelector(
        ({ share }) => share
    );
    const dispatch = useDispatch();


    const { getFieldDecorator, validateFields, setFieldsValue } = form;

    const [contentCount, setContentCount] = useState([]);
    const [contentData, setContentData] = useState({ sortNo: [], isShare: [] });
    
    const remove = (i) => {
        const filtered = contentCount.filter((e,index) => index !== i);
        setContentCount(filtered)
        shareData.sortNo = shareData.sortNo.filter((e, index) => index !== i);
        dispatch(share(shareData))
    }

    useEffect(() => {

        editFormContents.map((item, i) => {
            contentCount.push("");
            const updateContentCount = [...contentCount];
            setContentCount(updateContentCount);

            _renderContentSection(i);

            let initContent = { ...contentData };
            initContent.sortNo[i] = item.sort;
            initContent.isShare[i] = item.share;

            setContentData(initContent);
            
            // for initial value set in redex store
            dispatch(share(initContent));
        })
    }, [editFormContents?.length]);

    const handleSubmit = e => {
        e.preventDefault();
        validateFields((err, values) => {
            if (!err) {
                console.log("Received values of form: ", values);

            }
        });
    };

    const _renderContentSection = (i) => {

        const addSortNo = (value) => {
            console.log(value, i);
            let sortList = { ...contentData };
            sortList.sortNo[i] = value;
            sortList.isShare[i] = false;
            setContentData(sortList);
            console.log(contentData);

            dispatch(share(sortList));
            // dispatch(share({ a: "test redux" }));
        };

        const addIsShare = (e) => {

            console.log(e.target.checked, i);
            let isShareList = { ...contentData };
            isShareList.isShare[i] = e.target.checked;
            setContentData(isShareList);
            dispatch(share(isShareList));
        };

        return (
          <div className="ant-row" key={"Ad_" + i}>
            <div className="ant-col-md-8">
              <InputNumber
                required
                placeholder="Sort No"
                onChange={addSortNo}
                value={contentData.sortNo[i]}
              />
              {/* <Checkbox defaultChecked={contentData.isShare[i]} onChange={addIsShare}>Checkbox</Checkbox> */}
            </div>
            <a href="#delete-share" title="Delete">
              <Popconfirm
                title="Are you sure delete this?"
                onConfirm={() => {
                    remove(i);
                }}
                onCancel={() => {}}
                okText="Yes"
                cancelText="No"
              >
                <span className="gx-link" title="Delete">
                  <i class="icon icon-trash"></i>
                </span>
              </Popconfirm>
            </a>
          </div>
        );
    }

    return (
        <div>
            <div className="ant-row hd-title gx-m-0">
                <div className="ant-col-md-12">
                    <h1>Manage Share</h1>
                </div>
                <div className="ant-col-md-12 rite-btn">
                    <Button
                        type="primary"
                        className="color-white"
                        onClick={() => {
                            contentCount.push("");
                            const updateContentCount = [...contentCount];
                            setContentCount(updateContentCount);
                        }}
                    >
                        <i class="icon icon-add"></i> Add
                    </Button>
                </div>
            </div>

            {
                contentCount?.map((item, index) => {
                    return _renderContentSection(index);
                })
            }
        </div>

    );
}

export default Form.create()(ShareSection);